import React from 'react';
import { useSearchParams } from 'react-router-dom';
import './AuthSuccess.css';

const AuthSuccess = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  React.useEffect(() => {
    if (token) {
      // Store token in localStorage or cookie
      localStorage.setItem('authToken', token);
      
      // Redirect to main app after a short delay
      setTimeout(() => {
        window.location.href = '/';
      }, 2000);
    }
  }, [token]);

  return (
    <div className="auth-success-container">
      <div className="auth-success-card">
        <div className="success-icon">
          <svg width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M9 12l2 2 4-4"></path>
            <circle cx="12" cy="12" r="10"></circle>
          </svg>
        </div>
        <h1>Authentication Successful!</h1>
        <p>You have been successfully logged in.</p>
        <p>Redirecting you to the main application...</p>
        <div className="loading-dots">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </div>
  );
};

export default AuthSuccess;
